import React, { useState } from 'react';
import './AuthModal.css';

function AuthModal({ isOpen, onClose, onAuthSuccess }) {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            // Almacenar la contraseña en localStorage
            localStorage.setItem('arnold_auth_token', password);
            onAuthSuccess();
            onClose();
        } catch (err) {
            setError('Error de autenticación. Inténtalo de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setPassword('');
        setError('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="auth-modal-overlay">
            <div className="auth-modal">
                <div className="auth-modal-header">
                    <h2>Acceso a Arnold</h2>
                    <button className="close-button" onClick={handleClose}>×</button>
                </div>
                <div className="auth-modal-body">
                    <p className="auth-description">
                        Sistema de asistencia personal Arnold. 
                        Ingresa tu contraseña personal para continuar.
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <label htmlFor="password">Contraseña:</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Ingresa la contraseña"
                                required
                                disabled={isLoading}
                            />
                        </div>
                        {error && <div className="error-message">{error}</div>}
                        <div className="auth-modal-actions">
                            <button 
                                type="button" 
                                onClick={handleClose}
                                className="cancel-button"
                                disabled={isLoading}
                            >
                                Cancelar
                            </button>
                            <button 
                                type="submit" 
                                className="submit-button"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Verificando...' : 'Acceder'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AuthModal;
